import { ColumnType, SeriesType } from '@pages/DiagramsCreateOrEdit/types'

import { columnBindTypes, columnOperations } from '../../../../../types/api/barChart.api'

export const getDefaultValue = (series: SeriesType[]): ColumnType => {
  return {
    code: '',
    title: '',
    fields: series.map(series => ({
      title: series.title,
      seriesId: series.id,
      bindType: columnBindTypes[0],
    })),
    id: undefined,
    object: undefined,
    operation: columnOperations[0],
    parameters: {},
    prefilter: '',
    command: undefined,
    commandParameters: [],
    commandBody: [],
    commandForEverySeries: false,
    jsForAllFields: false,
    jsCreateValue: undefined,
    color: '#000000',
  }
}
